export default "__VITE_ASSET__C0YmCAJq__"